/*
 *
 * This contains all the text for the UserProfile component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.signup';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Create a new account',
    },
});
